export default function About() {
  return (
    <section id="about" className="py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-start">
          <div className="lg:col-span-3">
            <p className="text-gray-500 text-sm font-light mb-4 tracking-wide">Who We Are</p>
            <h2 className="text-5xl md:text-6xl font-extrabold text-gray-900 leading-tight mb-8">
              Expert Team<br />
              Building Tomorrow
            </h2>
          </div>
          
          <div className="lg:col-span-2">
            <p className="text-gray-700 text-base leading-relaxed mb-6">
              RITMO, d. o. o. is a dedicated team of iOS development specialists committed to creating innovative mobile solutions that make a real difference in users' daily lives.
            </p>
            <p className="text-gray-700 text-base leading-relaxed mb-6">
              Our expertise spans across security, performance optimization, and user experience design. We believe that great applications are built on a foundation of technical excellence and deep understanding of user needs.
            </p>
            <p className="text-gray-700 text-base leading-relaxed">
              With a focus on quality and innovation, we develop products that not only meet but exceed the expectations of modern iOS users. Our applications, including VPN and Cleaner solutions, are trusted by thousands of users worldwide.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-20">
          <div className="bg-white rounded-2xl p-8 shadow-sm">
            <div className="w-14 h-14 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-team-line text-teal-600 text-2xl w-6 h-6 flex items-center justify-center"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Experienced Team</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              Our developers bring years of iOS development experience and stay current with the latest Apple technologies and best practices.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-sm">
            <div className="w-14 h-14 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-focus-3-line text-teal-600 text-2xl w-6 h-6 flex items-center justify-center"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">User-Centric Approach</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              Every feature we build is designed with the end user in mind, ensuring intuitive interfaces and seamless experiences.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-sm">
            <div className="w-14 h-14 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-rocket-line text-teal-600 text-2xl w-6 h-6 flex items-center justify-center"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Continuous Innovation</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              We constantly explore new technologies and methodologies to deliver cutting-edge solutions that push boundaries.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}